import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/t3_BWwtJi/0/woongbee/homepage/front/src/app/homepage/template/page.jsx");
